:host {
  display: block;
  overflow: hidden;
  background: white;
  --font-family: Arial, sans-serif;
  --font-size: 0.9rem;
  --content-padding: 1rem;
  --brand-color: #666;
  --discount-bg: #e74c3c;
  --discount-color: white;
  --rating-color: inherit;
  --placeholder-bg: #f5f5f5;
  --placeholder-color: #999;
  --slot-padding: 1rem;
  --slot-padding-top: 0.5rem;
  --loading-opacity: 0.7;
}

:host([loading]) {
  opacity: var(--loading-opacity);
}

.card {
  font-family: var(--font-family);
  font-size: var(--font-size);
  padding: var(--content-padding);
  display: flex;
  flex-direction: column;
  height: 100%;
}

.image {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.3s ease;
}

.image.alternate .img.alternate {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}

.image.alternate:hover .img.primary {
  opacity: 0;
}

.image.alternate:hover .img.alternate {
  opacity: 1;
}


.brand {
  margin-bottom: 0.5rem;
}

.title {
  margin: 0 0 0.5rem;
}

.link {
  text-decoration: none;
  color: var(--link-color);
  font-weight: 500;
}

.price {
  align-items: center;
  margin: 0.5rem 0;
  display: flex;
  gap: 0.5rem;
}

.price-current {
  color: var(--price-color);
}

.price-original {
  text-decoration: line-through;
}

.discount {
  background: var(--discount-bg);
  color: var(--discount-color);
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  width: fit-content;
}

.image.placeholder {
  background: var(--placeholder-bg);
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--placeholder-color);
}

.image.placeholder::after {
  content: "No image available";
}

